import { showToast } from '../../application/utils/toast.util';
import axios from 'axios';

declare global {
  interface Window {
    dataLayer: any[];
    M: any;
  }
}

export function GetPlanInfo(
  planCode: string,
  setLoading: (loading: boolean) => void,
): Promise<any> {
  return new Promise((resolve, reject) => {
    setLoading(true);
    axios
      .get(`?plan_code=${planCode}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      .then(({data}) => {
        const {plan} = data;
        if (!plan) {
          reject('Plano não encontrado');
        } else {
          document.title = `${plan.name} - ${document.title}`;
          trackCheckoutEvent('view_plan', {
            event: 'ConsultCheckout',
            status: '200',
            planCode: planCode,
            planName: plan.name,
            planValue: plan.value,
          });
          resolve({plan});
        }
      })
      .catch((error) => {
        if (window.M) {
          window.showToast({html: error.message});
        }
        console.log(' error no plano : ', error);
        trackCheckoutEvent('error_plan', {
          event: 'ConsultCheckout',
          status: '404',
          planCode: planCode,
          error: error.message,
        });
        reject(error);
      })
      .finally(() => {
        setLoading(false);
      });
  });
}

export function trackCheckoutEvent(eventName: string, data: any) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    timestamp: new Date().toISOString(),
    ...data,
  });
}

export function trackCheckoutStep(step: string, planCode: string) {
  trackCheckoutEvent('checkout_progress', {
    step,
    planCode,
  });
}

function setPurchaseDataLayer(checkoutForm: any) {
  return window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: checkoutForm.checkout.customer.email,
      value: checkoutForm.checkout.plan.value,
      currency: 'BRL',
      products: [
        {
          affiliation: 'Checkout Millbody',
          id: checkoutForm.checkout.plan_code,
          name: checkoutForm.checkout.plan.name,
          price: checkoutForm.checkout.plan.value,
          quantity: 1,
        },
      ],
      items: [
        {
          affiliation: 'Checkout Millbody',
          id: checkoutForm.checkout.plan_code,
          name: checkoutForm.checkout.plan.name,
          price: checkoutForm.checkout.plan.value,
          quantity: 1,
        },
      ],
    },
  });
}

function setPaymentInfoDataLayer(checkoutForm: any) {
  return window.dataLayer.push({
    event: 'add_payment_info',
    ecommerce: {
      currency: 'BRL',
      products: [
        {
          affiliation: 'Checkout Millbody',
          id: checkoutForm.checkout.plan_code,
          name: checkoutForm.checkout.plan.name,
          price: checkoutForm.checkout.plan.value,
          quantity: 1,
        },
      ],
      items: [
        {
          affiliation: 'Checkout Millbody',
          id: checkoutForm.checkout.plan_code,
          name: checkoutForm.checkout.plan.name,
          price: checkoutForm.checkout.plan.value,
          quantity: 1,
        },
      ],
    },
  });
}

export function CreateSubscription(
  checkoutForm: any,
  setLoading: (loading: boolean) => void,
): Promise<any> {
  return new Promise((resolve, reject) => {
    setLoading(true);
    trackCheckoutEvent('begin_checkout', {
      planCode: checkoutForm.checkout.plan_code,
      planValue: checkoutForm.checkout.plan.value,
    });

    axios
      .post('', checkoutForm, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      .then(({data}) => {
        if (checkoutForm.checkout.plan.store != 'stripe') {
          setPurchaseDataLayer(checkoutForm);
          resolve(data);
        } else {
          const {checkout_type, url} = data;
          if (checkout_type == 'redirect') {
            setPaymentInfoDataLayer(checkoutForm);
            window.location.replace(url);
          } else {
            trackCheckoutEvent('checkout_error', {
              planCode: checkoutForm.checkout.plan_code,
              error: 'Invalid checkout type',
            });
            reject(data);
          }
        }
      })
      .catch((error) => {
        if (window.M) {
          window.showToast({html: error.message});
        }
        console.log(' error no plano : ', error);
        trackCheckoutEvent('checkout_error', {
          planCode: checkoutForm.checkout.plan_code,
          error: error.message,
        });
        reject(error);
      })
      .finally(() => {
        setLoading(false);
      });
  });
}

export const SetStyle = ({
  colors,
  dimensions,
  fontSizes,
}: {
  colors: any;
  dimensions: any;
  fontSizes: any;
}) => {
  const checkoutApp = document.getElementById('checkout-app');
  if (!checkoutApp) return;

  let style = document.createElement('style');
  let css = `
    body, input, select, p, span {
      color: ${colors.text || '#333333'};
    }
    body, #checkout-app {
      background-color: ${colors.background || '#EEEEEE'} !important;
    }
    .container {
      background-color: ${colors.body || '#EEEEEE'};
      padding: ${dimensions.marginDefault || 10}px !important;
    }
    .btn {
      box-sizing: border-box !important;
      padding: 0 ${dimensions.marginDefault || 10}px !important;
    }
    .btn-primary{
      background-color: ${colors.primary || '#039be5'};
      border-radius: ${dimensions.borderRadius || 4}px;
      color: ${colors.primaryText || '#FFF'} 
    }
    a{
      color: ${colors.primary || '#039be5'} !important;
    }
    .checkout-form .input-field {
      margin-bottom: 0.5rem;
      margin-top: 0.5rem;
      width: 100%;
    }
    .errors {
      font-size: ${fontSizes.small || '10'}px;
      padding: 0 ${dimensions.marginDefault || 10}px !important;
      margin-top: -15px;
    }
    h1{
      font-size: ${fontSizes.h1 || '32'}px;
      font-weight: 900;
    }
    h2{
      font-size: ${fontSizes.h2 || '28'}px;
      font-weight: 900;
    }
    .flow-text{
      font-weight: 900;
    }
    .form-select .input-field{
      width: 100%;
    }
    .col > .col {
      padding: 0px !important;
    }
    input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not(.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) {
      border-bottom: 1px solid ${colors.primary || '#039be5'};
      box-shadow: 0 1px 0 0 ${colors.primary || '#039be5'};
    }
    input:not([type]):focus:not([readonly])+label, input[type=text]:not(.browser-default):focus:not([readonly])+label, input[type=password]:not(.browser-default):focus:not([readonly])+label, input[type=email]:not(.browser-default):focus:not([readonly])+label, input[type=url]:not(.browser-default):focus:not([readonly])+label, input[type=time]:not(.browser-default):focus:not([readonly])+label, input[type=date]:not(.browser-default):focus:not([readonly])+label, input[type=datetime]:not(.browser-default):focus:not([readonly])+label, input[type=datetime-local]:not(.browser-default):focus:not([readonly])+label, input[type=tel]:not(.browser-default):focus:not([readonly])+label, input[type=number]:not(.browser-default):focus:not([readonly])+label, input[type=search]:not(.browser-default):focus:not([readonly])+label, textarea.materialize-textarea:focus:not([readonly])+label {
      color: ${colors.primary || '#039be5'};
    }
    .errors{
      color: red;
    }
  `;
  style.appendChild(document.createTextNode(css));
  checkoutApp.prepend(style);
};
